module.exports = __webpack_public_path__ + "img/hb-3.59eba9f8.png";